const ABOUT_ADDRESS_EDITS_MODAL = 'ABOUT_ADDRESS_EDITS_MODAL';
const ADD_SPECIAL_OFFER_MODAL = 'ADD_SPECIAL_OFFER_MODAL';
const ARCHIVE_PROPERTY_MODAL = 'ARCHIVE_PROPERTY_MODAL';
const BILLING_ADD_PAYMENT_MODAL = 'BILLING_ADD_PAYMENT_MODAL';
const BLOCKED_USER_MODAL = 'BLOCKED_USER_MODAL';
const BOOST_AD_PREVIEWS = 'BOOST_AD_PREVIEWS';
const CONFIRMATION_MODAL = 'CONFIRMATION_MODAL';
const CONSOLIDATED_PROPERTY_LIST_MODAL = 'CONSOLIDATED_PROPERTY_LIST_MODAL';
const EDIT_UNIT_MODAL = 'EDIT_UNIT_MODAL';
const EDIT_PROPERTY_TYPE_MODAL = 'EDIT_PROPERTY_TYPE_MODAL';
const ENABLE_APPLICATIONS_MODAL = 'ENABLE_APPLICATIONS_MODAL';
const ERROR_MODAL = 'ERROR_MODAL';
const FEED_LISTING_DEACTIVATE_CONFIRMATION_HAS_ERROR_MODAL = 'FEED_LISTING_DEACTIVATE_CONFIRMATION_HAS_ERROR_MODAL';
const FEED_LISTING_DEACTIVATE_CONFIRMATION_MODAL = 'FEED_LISTING_DEACTIVATE_CONFIRMATION_MODAL';
const FEED_LISTING_DEACTIVATE_CONFIRMATION_THANKS_MODAL = 'FEED_LISTING_DEACTIVATE_CONFIRMATION_THANKS_MODAL';
const FEED_LISTING_DEACTIVATE_MODAL = 'FEED_LISTING_DEACTIVATE_MODAL';
const INVITE_TO_APPLY_MODAL = 'INVITE_TO_APPLY_MODAL';
const MODAL_ADD_PROPERTY_UPDATE_DISPLAY = 'MODAL_ADD_PROPERTY_UPDATE_DISPLAY';
const MODAL_ENABLE_APPLICATIONS_UPDATE_DISPLAY = 'MODAL_ENABLE_APPLICATIONS_UPDATE_DISPLAY';
const MODAL_IMAGE_CAROUSEL_UPDATE_DISPLAY = 'MODAL_IMAGE_CAROUSEL_UPDATE_DISPLAY';
const MODAL_PARENT_SELECTOR = 'app-root .App';
const MODAL_SYNDICATION_STATUS_UPDATE = 'MODAL_SYNDICATION_STATUS_UPDATE';
const NOTIFICATION_MODAL = 'NOTIFICATION_MODAL';
const PAID_INCLUSION_DEACTIVATION_MODAL = 'PAID_INCLUSION_DEACTIVATION_MODAL';
const PAID_INCLUSION_PAYMENT_MODAL = 'PAID_INCLUSION_PAYMENT_MODAL';
const PAID_INCLUSION_VALUE_PROP_MODAL = 'PAID_INCLUSION_VALUE_PROP_MODAL';
const PAYMENT_INFO_MODAL = 'PAYMENT_INFO_MODAL';
const POST_ACTIVATION_MODAL = 'POST_ACTIVATION_MODAL';
const POST_DEACTIVATION_MODAL = 'POST_DEACTIVATION_MODAL';
const PRE_ACTIVATION_MODAL = 'PRE_ACTIVATION_MODAL';
const RESEND_COMPANY_INVITE_MODAL = 'RESEND_COMPANY_INVITE_MODAL';
const SELECT_TOUR_MODAL = 'SELECT_TOUR_MODAL';
const SHOULD_RELOAD_ON_LOGIN_SUCCESS = 'SHOULD_RELOAD_ON_LOGIN_SUCCESS';
const USER_MANAGEMENT_PROPERTY_LIST_MODAL = 'USER_MANAGEMENT_PROPERTY_LIST_MODAL';
const VERIFY_EMAIL_FAILURE_MODAL = 'VERIFY_EMAIL_FAILURE_MODAL';
const VERIFY_EMAIL_MODAL = 'VERIFY_EMAIL_MODAL';
const VIEW_TOUR_MODAL = 'VIEW_TOUR_MODAL';

const ModalConstants = {
    ABOUT_ADDRESS_EDITS_MODAL,
    ARCHIVE_PROPERTY_MODAL,
    EDIT_PROPERTY_TYPE_MODAL,
    ERROR_MODAL,
    ADD_SPECIAL_OFFER_MODAL,
    BILLING_ADD_PAYMENT_MODAL,
    BLOCKED_USER_MODAL,
    BOOST_AD_PREVIEWS,
    CONFIRMATION_MODAL,
    CONSOLIDATED_PROPERTY_LIST_MODAL,
    EDIT_UNIT_MODAL,
    ENABLE_APPLICATIONS_MODAL,
    FEED_LISTING_DEACTIVATE_CONFIRMATION_HAS_ERROR_MODAL,
    FEED_LISTING_DEACTIVATE_CONFIRMATION_MODAL,
    FEED_LISTING_DEACTIVATE_CONFIRMATION_THANKS_MODAL,
    FEED_LISTING_DEACTIVATE_MODAL,
    INVITE_TO_APPLY_MODAL,
    MODAL_ADD_PROPERTY_UPDATE_DISPLAY,
    MODAL_ENABLE_APPLICATIONS_UPDATE_DISPLAY,
    MODAL_IMAGE_CAROUSEL_UPDATE_DISPLAY,
    MODAL_PARENT_SELECTOR,
    MODAL_SYNDICATION_STATUS_UPDATE,
    NOTIFICATION_MODAL,
    PAID_INCLUSION_DEACTIVATION_MODAL,
    PAID_INCLUSION_PAYMENT_MODAL,
    PAID_INCLUSION_VALUE_PROP_MODAL,
    PAYMENT_INFO_MODAL,
    POST_ACTIVATION_MODAL,
    POST_DEACTIVATION_MODAL,
    PRE_ACTIVATION_MODAL,
    RESEND_COMPANY_INVITE_MODAL,
    SELECT_TOUR_MODAL,
    SHOULD_RELOAD_ON_LOGIN_SUCCESS,
    USER_MANAGEMENT_PROPERTY_LIST_MODAL,
    VERIFY_EMAIL_FAILURE_MODAL,
    VERIFY_EMAIL_MODAL,
    VIEW_TOUR_MODAL,
};

export default ModalConstants;
